module.exports = "<div #wrapper class=\"{{innerStyle}}\" [hidden]=\"hidden\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/list/list-item.component.html
// module id = 77
// module chunks = 0 1